var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showKicker && _vm.kickerText && !_vm.hideImage && _vm.imageSrc)?_c('card-text',{class:['kicker ff-flama fs-sm fw-bold m-2 px-1 py-1 tt-uppercase',
           _vm.publicationAwareKickerClasses(_vm.kickerClasses), _vm.getKickerStyle()]},[_vm._v("\n  "+_vm._s(_vm.kickerText)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }